<section class="book-modal__section">
  <p *ngIf="sectionTitle" class="book-modal__headline uppercase">{{ sectionTitle }}</p>
  <p *ngIf="sectionText" class="book-modal__label">{{ sectionText }}</p>
  <ng-content></ng-content>
</section>
